import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { syncVendorSettings } from '../store/LabData/LabDataSlice';
import { authentication } from '../store/Auth/LoginSlice';
import { getJwtToken } from '../utilities/authentication';
import { vendorQueryOptions } from './fetchers/vendor';
import { meQueryOptions } from './fetchers/me';
import { unreadCountQueryOptions } from './fetchers/notifications';

/**
 * Prefetches shared shell data once for the authenticated layout:
 * - GET /api/vendor (vendor settings → Redux)
 * - GET /me (current user → Redux / localStorage; React Query cache)
 * - GET /notifications/unread-count (shared React Query cache for NavBar)
 */
const ShellDataProvider = ({ children }) => {
  const dispatch = useDispatch();
  const vendorQuery = useQuery(vendorQueryOptions());
  const meQuery = useQuery(meQueryOptions());

  useQuery(unreadCountQueryOptions());

  useEffect(() => {
    if (vendorQuery.data) {
      dispatch(syncVendorSettings(vendorQuery.data));
    }
  }, [vendorQuery.data, dispatch]);

  useEffect(() => {
    const token = getJwtToken();
    const user = meQuery.data;
    if (!token || !user) {
      return;
    }
    dispatch(authentication({ token, user }));
  }, [meQuery.data, dispatch]);

  return children;
};

export default ShellDataProvider;
